module.exports = __webpack_public_path__ + "img/sdg1_id.f3766407.svg";